import { FDSSNInput } from '@facet-wealth/design';
import React from 'react';
import { inputDefaultProps, inputPropTypes } from 'Packages/FacetDesign/Components/propTypes';
import { useDataAttrs } from 'Helpers/Testing';

const SSNInput = (props) => {
  const {
    alignSelf,
    flex,
    flexGrow,
    flexShrink,
    fullWidth,
    disabled,
    error,
    helperTextValue,
    label,
    onBlur,
    onChange,
    onFocus,
    placeholder,
    readonly,
    required,
    size,
    value,
    labelPlacement,
    ...rest
  } = props;

  return (
    <FDSSNInput
      {...useDataAttrs(rest)}
      alignSelf={alignSelf}
      disabled={disabled || readonly}
      error={error}
      flex={flex}
      flexGrow={flexGrow}
      flexShrink={flexShrink}
      fullWidth={fullWidth}
      helperText={helperTextValue}
      label={label}
      onBlur={onBlur}
      onChange={(val) => (val === undefined ? onChange('') : onChange(val))}
      onFocus={onFocus}
      placeholder={placeholder}
      required={required}
      size={size}
      labelPlacement={labelPlacement}
      value={value === '' ? undefined : value}
    />
  );
};

SSNInput.defaultProps = {
  alignSelf: inputDefaultProps.alignSelf,
  disabled: inputDefaultProps.disabled,
  error: inputDefaultProps.error,
  flex: inputDefaultProps.flex,
  flexGrow: inputDefaultProps.flexGrow,
  flexShrink: inputDefaultProps.flexShrink,
  fullWidth: inputDefaultProps.fullWidth,
  helperTextValue: inputDefaultProps.helperTextValue,
  label: inputDefaultProps.label,
  onBlur: inputDefaultProps.onBlur,
  onFocus: inputDefaultProps.onFocus,
  placeholder: inputDefaultProps.placeholder,
  readonly: inputDefaultProps.readonly,
  required: inputDefaultProps.required,
};

SSNInput.propTypes = {
  alignSelf: inputPropTypes.alignSelf,
  disabled: inputPropTypes.disabled,
  flex: inputPropTypes.flex,
  flexGrow: inputPropTypes.flexGrow,
  flexShrink: inputPropTypes.flexShrink,
  label: inputPropTypes.label,
  placeholder: inputPropTypes.placeholder,
  size: inputPropTypes.size.isRequired,
  helperTextValue: inputPropTypes.helperTextValue,
  error: inputPropTypes.error,
  value: inputPropTypes.value.isRequired,
  onBlur: inputPropTypes.onBlur,
  onChange: inputPropTypes.onChange.isRequired,
  onFocus: inputPropTypes.onFocus,
  fullWidth: inputPropTypes.fullWidth,
  labelPlacement: inputPropTypes.labelPlacement,
  readonly: inputPropTypes.readonly,
  required: inputPropTypes.required,
};

const SSNInputSmall = (props) => {
  return <SSNInput {...props} size="sm" />;
};

const SSNInputLarge = (props) => {
  return <SSNInput {...props} size="lg" />;
};

export { SSNInputSmall, SSNInputLarge };
